import React from 'react'

import { Portlet } from '_zari/core'

import * as CodigosTransaccionesConstant from 'constants/codigosTransacciones'

import * as TempInventarioCrud from 'services/tempInventario.service'

import MainForm from './mainForm'

const portletBreadcrumbs = [
  {
    name: 'Ingreso Manual',
    path: `/${CodigosTransaccionesConstant.INVENTARIOS_INGRESOMANUAL_LISTA}`
  },
  {
    name: 'Editar'
  }
]

const EditarDetalles = ({ match, history }) => {
  const [tempInventarioInfo, setTempInventarioInfo] = React.useState(null)

  React.useEffect(() => {
    TempInventarioCrud.getTempInventario(match.params.idTempInventario).then(({ data }) => {
      const nuevosDetalles = data.detalles.map((x, k) => {
        return {
          ...x,
          _idFila: k,
          __filaActiva: false,
          __focusCantidad: false,
          __focusPrecio: false,
          cantidad: `${x.cantidad}`,
          nombreUnidadDeMedida: x.unidadMedida
        }
      })
      setTempInventarioInfo({
        ...data,
        detalles: nuevosDetalles
      })
    })
  }, [match.params.idTempInventario])

  return (
    <>
      {tempInventarioInfo && (
        <Portlet>
          <Portlet.Header title='Ingreso Manual' breadcrumbs={portletBreadcrumbs} />
          <Portlet.Body>
            <MainForm history={history} tempInventarioInfo={tempInventarioInfo} />
          </Portlet.Body>
        </Portlet>
      )}
    </>
  )
}

export default EditarDetalles
